<template>
    <div class="photoHistory_box">
        <div class="operation">
            <span class="all unbind"><i></i> <span i18n="history_all">{{$t("SelectAll")}}</span></span>
            <span class="open unbind" i18n="history_open">{{$t("open")}}</span>
            <span class="down unbind" i18n="history_down">{{$t("Download")}}</span>
            <span class="delete unbind" i18n="history_delete">{{$t("Delete")}}</span>
            <span class="clear unbind" i18n="history_clear">{{$t("Clear")}}</span>
        </div>
        <img class="load" src="../assets/images/load.svg" alt="Load">
        <div class="noHistory">
            <img src="../assets/images/no-history.svg" alt="No History">
            <p i18n="no_history">{{$t("noHistory")}}</p>
        </div>
        <ul class="scroll_box">
        </ul>
    </div>
</template>

<script>
import upload from "../assets/js/upload"
import Japp from "@/assets/js/app"
export default {
    mounted(){
$('.header .history').click(function(e){
    e.stopPropagation();
    $('.photo_toggle_box').hide();
    $('.photo_rights').hide()
    $('.header .login ul').hide()
    $('.photoHistory_box ul').html('').hide();
    $('.photoHistory_box .noHistory').hide();
    $('.photoHistory_box .load').show()
    if(user){
        $('.photoHistory_box').toggleClass('active')
        taskList(Japp.product_id)
    }else{
        $('.maskMember').show()
    }
})
function taskList(id){
    $.post(
        post_url+"/task/list",
        {
            e_id:murmur,
            t_id:user.t_id,
            token:user.token,
            product_id:id
        },
        function(data){
            console.log(data);
            error_fn(data.error);
            switch(data.error){
                case 0:
                    for(var i=0;i<data.tasks.length;i++){
                        var attach=JSON.parse(data.tasks[i].attach);
                        console.log(attach);
                        try{
                            var operation=`
                                <i class="open" data="${attach.downloadURL}"></i>
                                <i class="delete"></i>
                                <!-- <i class="copy-link"></i> -->
                                <i class="down watermarker-image" download="${attach.downloadURL}"></i>
                                `
                            $('.photoHistory_box ul').append(`
                            <li class="flex_box" task_id="${data.tasks[i].id}">
                                <i class="check"></i>
                                <div class="img" style="background-image: url(${attach.icon});"></div>
                                <div class="text">
                                    <p class="name">${attach.name}</p>
                                    <p class="time">${getdate(1,attach.expire)} <span class="effective">(${i18nWaterMark.global.t('history_will')} ${surplusTime(data.tasks[i].ts_create,attach.expire)})</span><span class="expired">${i18nWaterMark.global.t('Expired')}</span></p>
                                </div>
                                <div class="box">
                                ${operation}
                                </div>
                            </li>
                            `);
                        }catch(e){
                            console.log(e);
                        }
                    }
                    if($('.photoHistory_box ul li').length==0){
                        $('.photoHistory_box ul').hide();
                        $('.photoHistory_box .noHistory').show();
                    }else{
                        $('.photoHistory_box .operation .all').removeClass('unbind');
                    }
                    // 过期处理
                    for(var i=0;i<$('.photoHistory_box ul li').length;i++){
                        if($('.photoHistory_box ul li').eq(i).find('.effective span').attr('num')<0){
                            $('.photoHistory_box ul li').eq(i).find('.open').addClass('unbind').css('opacity',0);
                            $('.photoHistory_box ul li').eq(i).find('.down').addClass('unbind').css('opacity',0);
                            $('.photoHistory_box ul li').eq(i).find('.effective').hide()
                            $('.photoHistory_box ul li').eq(i).find('.expired').show()
                            $('.photoHistory_box ul li').eq(i).addClass('expired')
                        }
                    }
                    // 禁用删除全部过期
                    if($('.photoHistory_box ul li.expired').length>0){
                        $('.photoHistory_box .operation .clear').removeClass('unbind')
                    }else{
                        $('.photoHistory_box .operation .clear').addClass('unbind')
                    }
                    break;
                case 26201:
                    error(i18n[lang].error_26201);
                    break;
                case 26202:
                    error(i18n[lang].error_26202);
                    break;
                
            }
            $('.photoHistory_box .load').hide();
            $('.photoHistory_box ul').show();
        }
    )
}
$('.photoHistory_box').click(function(e){
    e.stopPropagation();
})
$('.photoHistory_box ul').on('click','li',function(){
    $(this).toggleClass('active')
    // 0没有选中,1有选中,2全部选中
    if(!$('.photoHistory_box ul li.active').length){
        $('.photoHistory_box .operation .all').removeClass('active').removeClass('semi');
    }else if($('.photoHistory_box ul li.active').length==$('.photoHistory_box ul li').length){
        $('.photoHistory_box .operation .all').addClass('active').removeClass('semi');
    }else{
        $('.photoHistory_box .operation .all').addClass('semi').removeClass('active');
    }
    // 禁用上部批量操作
    if($('.photoHistory_box ul li.active').length>0){
        $('.photoHistory_box .operation>span').removeClass('unbind');
    }else{
        $('.photoHistory_box .operation .all').siblings().addClass('unbind');
    }
    // 禁用Open
    if($('.photoHistory_box ul li.active').length!=1){
        $('.photoHistory_box .operation .open').addClass('unbind')
    }
    if($('.photoHistory_box ul li.active.expired').length==1&&$('.photoHistory_box ul li.active').length==1){
        $('.photoHistory_box .operation .open').addClass('unbind')
    }
    // 禁用下载
    if($('.photoHistory_box ul li.active.expired').length==$('.photoHistory_box ul li.active').length){
        $('.photoHistory_box .operation .down').addClass('unbind')
    }
    // 禁用删除全部过期
    if($('.photoHistory_box ul li.expired').length>0){
        $('.photoHistory_box .operation .clear').removeClass('unbind')
    }else{
        $('.photoHistory_box .operation .clear').addClass('unbind')
    }
});
$('.photoHistory_box ul').on('click','.box i',function(e){
    e.stopPropagation();
});
// 删除一条历史
$('.photoHistory_box ul').on('click','.delete',function(){
    historyDelete($(this));
});
// 记录下载 去水印
$('.photoHistory_box ul').on('click','.down.watermarker-image',function(){
    if($(this).attr('class').indexOf('unbind')>-1){
        return false;
    }
    $(this).addClass('unbind');
    var that=$(this);
    upload.getDownload(2,$(this).attr('download').split("||"),function(){
        that.removeClass('unbind');
    })
});
// 全选的操作
$('.photoHistory_box .operation .all').click(function(){
    if($(this).attr('class').indexOf('unbind')>-1){
        return false;
    }
    $(this).toggleClass('active').removeClass('semi');
    if($(this).attr('class').indexOf('active')>-1){
        $('.photoHistory_box ul li').addClass('active');
    }else{
        $('.photoHistory_box ul li').removeClass('active');
    }
    // 禁用上部批量操作
    if($('.photoHistory_box ul li.active').length>0){
        $('.photoHistory_box .operation>span').removeClass('unbind');
    }else{
        $('.photoHistory_box .operation .all').siblings().addClass('unbind');
    }
    // 禁用Open
    if($('.photoHistory_box ul li.active').length!=1){
        $('.photoHistory_box .operation .open').addClass('unbind')
    }
    // 禁用删除全部过期
    if($('.photoHistory_box ul li.active').length==$('.photoHistory_box ul li.expired').length){
        $('.photoHistory_box .operation .down').addClass('unbind');
    }
    if($('.photoHistory_box ul li.expired').length>0){
        $('.photoHistory_box .operation .clear').removeClass('unbind')
    }else{
        $('.photoHistory_box .operation .clear').addClass('unbind')
    }
});
// 全选下载
$('.photoHistory_box .operation .down').click(function(){
    if($('.photoHistory_box ul li.active').length<=0){
        return false
    }
    if($(this).attr('class').indexOf('unbind')>-1){
        return false;
    }
    for(var i=0;i<$('.photoHistory_box ul li.active').length;i++){
        if($('.photoHistory_box ul li.active').eq(i).attr('class').indexOf('expired')<0){
            $('.photoHistory_box ul li.active').eq(i).find('.down').click();
        }
    }
});
// 全选删除
$('.photoHistory_box .operation .delete').click(function(){
    if($('.photoHistory_box ul li.active').length<=0){
        return false
    }
    if($(this).attr('class').indexOf('unbind')>-1){
        return false;
    }
    $('.photoHistory_box .operation>span').addClass('unbind')
    for(var i=0;i<$('.photoHistory_box ul li.active').length;i++){
        historyDelete($('.photoHistory_box ul li.active').eq(i).find('.delete'));
    }
    $('.photoHistory_box .operation>span').removeClass('unbind')
});
// 打开历史记录的图片
$(".photoHistory_box ul").on('click','.open',function(){
    if($(this).attr('class').indexOf('unbind')>-1){
        return false;
    }
    $(this).addClass('unbind');
    var that=$(this);
    upload.getDownload(3,$(this).siblings('.down').attr('download').split("||"),function(){
        that.removeClass('unbind');
    })
});
$('.photoHistory_box .operation .open').click(function(){
    if($('.photoHistory_box ul li.active').length<=0){
        return false
    }
    if($(this).attr('class').indexOf('unbind')>-1){
        return false;
    }
    for(var i=0;i<$('.photoHistory_box ul li.active').length;i++){
        $('.photoHistory_box ul li.active').eq(i).find('.open').click();
    }
});
//删除全部过期
$('.photoHistory_box .operation .clear').click(function(){
    if($(this).attr('class').indexOf('unbind')>-1){
        return false;
    }
    $('.photoHistory_box .operation .clear').addClass('unbind')
    for(var i=0;i<$('.photoHistory_box ul li.expired').length;i++){
        historyDelete($('.photoHistory_box ul li.expired').eq(i).find('.delete'));
    }
});
// 时间戳转换
function getdate(type,time) {
    if(type){
        var now=new Date((time-60*60*24*7)*1000)
    }else{
        var now=new Date(time*1000)
    }
    var y=now.getFullYear()
    var m=now.getMonth()+1
    var d=now.getDate()
    if(type==1){
        return (d < 10 ? "0" + d : d) + "/" + (m < 10 ? "0" + m : m) + "/" + y + " " + now.toTimeString().substr(0, 8);
    }else{
        return (d < 10 ? "0" + d : d) + "-" + (m < 10 ? "0" + m : m) + "-" + y
    }
}
// 计算还剩余多长时间过去
function surplusTime(create,expire){
    var date =Date.parse(new Date())
    console.log(date);
    var time=(expire-date/1000)/(60*60*24)
    if(time>1){
        return '<span num="'+parseInt(time)+'">'+parseInt(time)+' '+'Day(s)</span>'
    }else{
        return '<span num="'+parseInt((expire-date/1000)/(60*24))+'">'+parseInt((expire-date/1000)/(60*24))+' '+'hours</span>'
    }
};
// 删除

function historyDelete(that){
    console.log(that);
    if(that.attr('class').indexOf('unbind')>-1){
        return false;
    }
    that.addClass('unbind');
    var task_id=that.parent().parent().attr('task_id')
    console.log(task_id);
    console.log(post_url);
    $.post(
        post_url.replace('/v9/','/v6/')+"task/update",
        {
            e_id:murmur,
            t_id:JSON.parse(getCookie('user')).t_id,
            token:JSON.parse(getCookie('user')).token,
            product_id:Japp.product_id,
            task_id:task_id,
            client_ip:'127.0.0.1',
            finish:1
        },
        function(data){
            console.log(data);
            error_fn(data.error)
            switch(data.error){
                case 0:
                    $.post(
                        post_url.replace('/v9/','/v6/')+"task/delete",
                        {
                            e_id:murmur,
                            t_id:JSON.parse(getCookie('user')).t_id,
                            token:JSON.parse(getCookie('user')).token,
                            product_id:Japp.product_id,
                            task_id:task_id,
                        },
                        function(data){
                            that.removeClass('unbind');
                            error_fn(data.error)
                            switch(data.error){
                                case 0:
                                    that.parent().parent().remove();
                                    $('.photoHistory_box ul li').eq(0).click();
                                    $('.photoHistory_box ul li').eq(0).click();
                                    if($('.photoHistory_box ul li').length==0){
                                        $('.photoHistory_box ul').hide();
                                        $('.photoHistory_box .noHistory').show();
                                        $('.photoHistory_box .operation>span').addClass('unbind');
                                    }
                                    break;
                                case 26101:
                                    error(i18n[lang].error_26101);
                                    break;
                                case 26102:
                                    error(i18n[lang].error_26102);
                                    break;
                                case 26103:
                                    error(i18n[lang].error_26103);
                                    break;
                                case 26104:
                                    error(i18n[lang].error_26104);
                                    break;
                                case 26105:
                                    error(i18n[lang].error_26105);
                                    break;
                                case 26106:
                                    error(i18n[lang].error_26106);
                                    break;
                            }
                            console.log(data);
                        }
                    ).fail(function(xhr){
                        overtime(26199);
                    });
                    break;
                case 26001:
                    error(i18n[lang].error_26001);
                    break;
                case 26002:
                    error(i18n[lang].error_26002);
                    break;
                case 26003:
                    error(i18n[lang].error_26003);
                    break;
                case 26004:
                    error(i18n[lang].error_26004);
                    break;
                case 26005:
                    error(i18n[lang].error_26005);
                    break;
                case 26006:
                    error(i18n[lang].error_26006);
                    break;
                case 26007:
                    console.log('26007')
                    break;
                case 26008:
                    error(i18n[lang].error_26008);
                    break;
            }
        }
    ).fail(function(xhr){
        overtime(26099);
    });
};

    }
}
</script>

<style>
.photoHistory_box{max-width: 735px;width: 95%;box-shadow: 0px 6px 13px -4px rgba(0, 0, 0, 0.5);border-radius: 18px;position: absolute;top: 70px; right: 30px;z-index: 99;background: #fff;padding-top: 25px;padding-bottom: 26px;display: none;}
.photoHistory_box.active{display: block;}
.photoHistory_box .operation{font-size: 16px;;padding-right: #333;line-height: 20px;padding-left: 30px;}
.photoHistory_box .operation span{margin-right: 18px;display: inline-block;cursor: pointer;}
.photoHistory_box .operation span.unbind{opacity: .5;}
.photoHistory_box .operation .all{padding-right: 16px;position: relative;}
.photoHistory_box .operation .all::after{clear: both;content: "";width: 1px;height: 14px;background: #B5B5B5;position: absolute;top: 3px;right: 0px;}
.photoHistory_box .operation .all i{width: 14px;height: 14px;background: url(../assets/images/unselect.svg);display: inline-block;margin-right: 6px;vertical-align: -1px;}
.photoHistory_box .operation .all.active i{background: url(../assets/images/select.svg);}
.photoHistory_box .operation .all.semi i{background: url(../assets/images/semi-select.svg);}
.photoHistory_box .operation .clear{opacity: 1;}
.photoHistory_box ul{margin-top: 15px;max-height: 300px;overflow: auto;}
.photoHistory_box ul li{padding: 10px 30px;-webkit-justify-content: flex-start;justify-content: flex-start;-webkit-align-items: center;align-items: center;}
.photoHistory_box ul li.active{display: flex;}
.photoHistory_box ul li:hover,.photoHistory_box ul li.active{background: #F1F8FF;}
.photoHistory_box ul li .check{width: 14px;height: 14px;background: url(../assets/images/unselect.svg);margin-right: 10px;}
.photoHistory_box ul li.active .check{background: url(../assets/images/select.svg);}
.photoHistory_box ul li .img{width: 96px;height: 54px;background-color: #000;background-size: contain;background-position: center center;background-repeat: no-repeat;}
.photoHistory_box ul li .text{margin-left: 10px;}
.photoHistory_box ul li .text .name{font-size: 16px;color: #333;line-height: 20px;}
.photoHistory_box ul li .text .time{font-size: 14px;color: #666;line-height: 20px;margin-top: 6px;}
.photoHistory_box ul li .text .time .expired{display: none;}
.photoHistory_box ul li .box{text-align: right;flex-grow: 1}
.photoHistory_box ul li .box i{display: inline-block;vertical-align: middle;margin-right: 20px;cursor: pointer;}
.photoHistory_box ul li .box .open{width: 11px;height: 14px;background: url(../assets/images/open.svg);}
.photoHistory_box ul li .box .open:hover{background: url(../assets/images/open-h.svg);}
.photoHistory_box ul li .box .delete{width: 16px;height: 14px;background: url(../assets/images/delete.svg);}
.photoHistory_box ul li .box .delete:hover{background: url(../assets/images/delete-h.svg);}
.photoHistory_box ul li .box .copy-link{width: 14px;height: 14px;background: url(../assets/images/copy-link.svg);}
.photoHistory_box ul li .box .copy-link:hover{background: url(../assets/images/copy-link-h.svg);}
.photoHistory_box ul li .box .down{width: 15px;height: 13px;background: url(../assets/images/down.svg);}
.photoHistory_box ul li .box .down:hover{background: url(../assets/images/down-h.svg);}
.photoHistory_box ul li .box .open.unbind,.photoHistory_box ul li .box .delete.unbind,.photoHistory_box ul li .box .down.unbind{width: 16px;height: 16px;background: url(../assets/images/load.svg);background-size: 100% 100%;-webkit-animation: rotate 1.5s infinite linear;-moz-animation: rotate 1.5s infinite linear;-o-animation: rotate 1.5s infinite linear;animation: rotate 1.5s infinite linear;cursor: auto;}
.photoHistory_box ul li.expired .text .name,.photoHistory_box ul li.expired .text .time{color: #999;}


.photoHistory_box .load{margin: 30px auto 0px;display: block;-webkit-animation: rotate 1.5s infinite linear;-moz-animation: rotate 1.5s infinite linear;-o-animation: rotate 1.5s infinite linear;animation: rotate 1.5s infinite linear;width: 60px;}
.photoHistory_box .noHistory{margin: 30px auto 0px;text-align: center;display: none;}
.photoHistory_box .noHistory img{margin: auto;display: block;}
.photoHistory_box .noHistory p{font-size: 14px;color: #666;line-height: 20px;margin-top: 10px;}
.scroll_box::-webkit-scrollbar {height: 8px;width: 4px;background: #fff;}
.scroll_box::-webkit-scrollbar-thumb{background: #f1f1f1;}
.scroll_box::-webkit-scrollbar-thumb:hover{background:#ddd}
.scroll_box::-webkit-scrollbar-thumb:active{background:#bbb}
@media screen and (max-width:980px){
    .photoHistory_box{
        left: 50%;
        right: unset;
        transform: translateX(-50%);
        top: 96px;
    }
}
</style>